<template lang="pug">
      v-dialog(v-model="dialog" persistent max-width="500px")
        v-card()
            v-card-title(class="headline grey lighten-2") Confirmation
            v-alert(:value='true' color="success")
                h3(style="text-align: center; font-weight:normal") Apakah anda yakin ingin resend notifikasi?
            v-card-actions
                v-spacer
                v-btn(color="green darken-1"  @click="closeModal();" ) Tidak
                v-btn(color="blue darken-1" :disabled="disable"  @click="resend(ip);") Ya
</template>

<script>
import axios from "axios";
import { mapState } from "vuex";
export default {
  name: "ResendPopUp",
  props: ["ip","dialogOpen"],
  data() {
    return {
      dialog: false,
      disable:false,
      userApproverID:'',
    };
  },
    mounted() {
      this.dialog = this.dialogOpen
    },
  computed: {
    ...mapState(["API_URL","token"]),
  },
  methods: {
    resend(ipId){
      if(ipId.ipForm === "BIB-HSE-PPO-F-012-02"){
        const dataIp = {ipNo : ipId.ipNo}
        const config = {
        method: "post",
        url: `${this.API_URL}/v1/requests/resendNotifAttachment`,
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${this.$store.state.token}`,
        },
        data: dataIp,
      };
         axios(config).then(res => {
          if(res){
              this.disable=false;
              this.$emit('interface', false)
              this.dialog = false
          }
        })
        .catch(err=>{
            this.disable=false;
            console.log(err)
        })
      }else{
        axios.get(`${this.$store.state.API_URL}/v1/requests/resendNotif?id=${ipId._id}`,{headers: {"Authorization": `Bearer ${this.token}`}})
        .then(res => {
          if(res){
              this.disable=false;
              this.$emit('interface', false)
              this.dialog = false
          }
        })
        .catch(err=>{
            this.disable=false;
            console.log(err)
        })
      }
    },
    closeModal(){
      this.dialog = false
      this.$emit('interface', false)
    },
    getCurrentApprover(){
        let wf = this.ip.ipWorkflow
        for(let i=0;i<wf.length;i++){
            if(wf[i].status == 7 || wf[i].status == 3){
                this.userApproverID = wf[i]._id ? wf[i]._id : wf[i].nik
                return wf[i].fullname ? wf[i].fullname : wf[i].name
            }
        }
    }
  }
};
</script>